var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQrBarcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 125,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.02325V10.0465H10.0465V0H0V5.02325ZM8.61128 5.0228V8.61084H1.4352V1.43476H8.61128V5.0228V5.0228Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.96 0.72V1.44H11.52V5.76H15.84V7.2H12.96V8.64H11.52V15.84H10.08V14.4H8.64V12.96H10.08V11.52H8.64V12.96H7.2V14.4H8.64V15.84H10.08V17.28H8.64V18.72H11.52V20.16H7.2V18.72H5.76V17.28H7.2V15.84H5.76V17.28H4.32V14.4H5.76V12.96H4.32V14.4H2.88V12.96H1.44V11.52H0V12.96H1.44V15.84H0V18.72H2.88V20.16H1.44V24.48H5.76V23.04H7.2V24.48H10.08V23.04H7.2V21.6H11.52V25.92H12.96V24.48H14.4V27.36H12.96V31.68H14.4V34.56H11.52V36H15.84V34.56H17.28V33.12H18.72V31.68H15.84V27.36H17.28V30.24H18.72V28.8H20.16V31.68H21.6V30.24H24.48V31.68H23.04V36H24.48V34.56H25.92V33.12H24.48V31.68H27.36V34.56H30.24V36H31.68V34.56H30.24V33.12H28.8V31.68H27.36V30.24H30.24V31.68H31.68V33.12H33.12V31.68H34.56V36H36V25.92H34.56V27.36H33.12V28.8H30.24V27.36H31.68V25.92H33.12V21.6H34.56V23.04H36V20.16H34.56V18.72H36V14.4H34.56V11.52H30.24V12.96H27.36V11.52H24.48V0H20.16V1.44H17.28V0H15.84V1.44H14.4V0H12.96V0.72ZM23.0399 2.16046V2.88046H21.5999V5.76046H23.0399V10.0805H21.5999V8.64046H20.1599V11.5205H24.4799V12.9605H27.3599V14.4005H25.9199V15.8405H24.4799V17.2805H25.9199V18.7205H27.3599V21.6005H28.7999V17.2805H31.6799V14.4005H33.1199V15.8405H34.5599V18.7205H33.1199V21.6005H31.6799V25.9205H30.2399V21.6005H28.7999V23.0405H23.0399V28.8005H20.1599V27.3605H17.2799V25.9205H15.8399V24.4805H14.3999V23.0405H12.9599V18.7205H14.3999V17.2805H12.9599V14.4005H14.3999V12.9605H18.7199V11.5205H17.2799V10.0805H15.8399V7.20046H17.2799V5.76046H15.8399V4.32046H12.9599V2.88046H17.2799V4.32046H20.1599V2.88046H21.5999V1.44046H23.0399V2.16046ZM14.3999 10.0808V11.5208H12.9599V8.64084H14.3999V10.0808ZM30.24 15.1198V15.8398H28.8V14.3998H30.24V15.1198ZM2.88004 16.5603V17.2803H4.32004V18.7203H5.76004V23.0403H2.88004V21.6003H4.32004V18.7203H2.88004V17.2803H1.44004V15.8403H2.88004V16.5603ZM28.8 26.6402V28.8002H24.48V24.4802H28.8V26.6402ZM34.56 29.5196V30.2396H33.12V31.6796H31.68V30.2396H33.12V28.7996H34.56V29.5196V29.5196Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9535 5.02325V10.0465H36V0H25.9535V5.02325ZM34.5648 5.0228V8.61084H27.3887V1.43476H34.5648V5.0228V5.0228Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 30.9764V35.9996H10.0465V25.9531H0V30.9764ZM8.61128 30.9767V34.5647H1.4352V27.3886H8.61128V30.9767V30.9767Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3023 33.8019V34.5345H18.8372V35.9996H21.7675V33.0693H20.3023V33.8019",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.93024 5.02369V7.11671H7.11628V2.93066H2.93024V5.02369",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5814 9.41892V10.0468H18.8372V8.79102H17.5814V9.41892",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6279 15.1294V17.2822H17.1628V18.7174H20.093V15.847H21.5581V23.0231H23.0232V20.1526H25.9535V18.7174H24.4884V17.2822H23.0232V15.847H24.4884V14.4118H23.0232V12.9766H21.5581V14.4118H20.093V12.9766H18.6279V15.1294",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6512 16.5351V17.163H15.907V15.9072H14.6512V16.5351",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6512 19.5485V20.2602H16.0744V21.6834H14.6512V23.1067H16.0744V24.5299H17.4977V25.9532H21.7674V24.5299H17.4977V21.6834H18.9209V20.2602H16.0744V18.8369H14.6512V19.5485",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1395 20.7207V21.3486H31.3954V20.0928H30.1395V20.7207",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9535 26.581V27.2089H27.2093V25.9531H25.9535V26.581",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8837 5.02369V7.11671H33.0697V2.93066H28.8837V5.02369",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.93024 30.9758V33.0689H7.11628V28.8828H2.93024V30.9758",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrBarcode);
export default __webpack_public_path__ + "static/media/qrBarcode.ea3ee34855ace7975b5188f6f1dba3cf.svg";
export { ForwardRef as ReactComponent };